<template>
  <InputSelect
    v-if="newDesign"
    ref="inputSelect"
    v-model="selectedValue"
    :clearable="clearable"
    :label="inputSelectorLabel"
    new-design
    :options="filteredTimeZoneOptions"
    :placeholder="$t('timezone_dropdown.placeholder')"
    :use-input="useInput"
    :validations="validations"
    @blur="onBlur"
    @filter="onFilter"
  />

  <QSelect
    v-else
    v-model="selectedValue"
    borderless
    :clearable="clearable"
    :dense="dense"
    emit-value
    :filled="filled"
    :label="label"
    map-options
    :options="timeZones"
    square
    use-input
    @filter="filterTimezones"
  />
</template>

<script>
const TIME_ZONES = Intl.supportedValuesOf("timeZone");

import { getLocaleText } from "shared/boot/i18n";
import { InputSelect } from "shared/components/base";

export default {
  name: "TimezoneDropdown",
  components: {
    InputSelect,
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    filled: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
    newDesign: {
      type: Boolean,
    },
    hideLabel: {
      type: Boolean,
    },
    label: {
      type: String,
      default: () => getLocaleText("timezone_dropdown.default_label"),
    },
    useInput: {
      type: Boolean,
    },
    validations: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      timeZones: TIME_ZONES,
      filterValue: "",
    };
  },
  computed: {
    filteredTimeZoneOptions() {
      return this.timeZones.filter((timeZone) =>
        timeZone.toLowerCase().includes(this.filterValue.toLowerCase())
      );
    },
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    inputSelectorLabel() {
      if (this.hideLabel) {
        return "";
      }

      return this.$t("timezone_dropdown.label");
    },
  },
  methods: {
    filterTimezones(val, update) {
      update(() => {
        const needle = val.toLowerCase();

        this.timeZones = TIME_ZONES.filter(
          (timeZone) => timeZone.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    onFilter(value) {
      this.filterValue = value;
    },
    onBlur() {
      if (!this.useInput) return;

      this.$refs.inputSelect.setFilterValue(this.selectedValue);
    },
  },
};
</script>
